import { Add, List } from "@material-ui/icons";
import { AppBarLinkButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { useLocation } from "react-router-dom";
import { ModuleAppBar } from "../ModuleAppBar";
import { CaseAllocation } from "./CaseAllocation";
import { DashboardFilterControls } from "./DashboardFilterControls";
import { DashboardPopver } from "./DashboardPopover";

export const DashboardAppBar: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <ModuleAppBar>
      <DashboardFilterControls />
      <DashboardPopver />
      <CaseAllocation />
      <AppBarLinkButton
        to={`${pathname}/list/new`}
        title="New"
        Icon={Add}
        dataTest="new-button"
      />
      <AppBarLinkButton
        to={`${pathname}/list`}
        title="All cases"
        Icon={List}
        dataTest="list-button"
      />
    </ModuleAppBar>
  );
};
